
<div class="d-flex flex-column h-100 p-4">
    <breadcrumb [items]="breadcrumb" *ngIf="!hideBreadcrumb"></breadcrumb>
    <h1 class="fs-3 fw-light mb-0" *ngIf="!hideBreadcrumb">{{ titlePage }}</h1>
    <mat-card *ngIf="loading.main || loading.mapa">
        <mat-card-content>            
            <mat-spinner class="mx-auto my-5"></mat-spinner>
            <div class="text-center">
                <h3>Carregando pontos do mapa...</h3>
            </div>            
        </mat-card-content>
    </mat-card>

    <div class="d-flex flex-column h-100" [ngClass]="{'d-none': loading.main || loading.mapa}">
        <div class="d-flex position-relative overflow-hidden h-100 mb-3">

            <!-- DIO INFOS -->
            <div id="map-infos" class="py-2 px-3">
                <div><strong>{{ dio.numero }}</strong> - {{ dio.servico ? dio.servico.titulo : '' }}</div>
                <div class="fs-7 lh-sm" *ngIf="dio.alocacao">
                    O equipamento {{ dio.alocacao.codigo }} ({{ dio.alocacao.equipamento.placa | mask: 'AAA-AAAA' }}) executou o serviço
                    no dia {{ dataInicioGPS | date:'dd/MM/yyyy HH:mm' }} até {{ dataFimGPS | date:'dd/MM/yyyy HH:mm' }}
                    resultando em {{ horasTrabalhadas }} trabalhados, {{ horasDisponiveis }} disponíveis e {{ kmRodados }} kms rodados.
                </div>
            </div>
            
            <!-- 2 POINTS INFOS -->
            <div class="map-left-side overflow-visible text-nowrap p-2 ps-3" [ngClass]="{'show': show.info2Points}" style="margin-top: 40px; margin-left: 60px;">
                <mat-spinner class="btn-spinner mx-auto my-5" *ngIf="loading.info2Points || !points.info2Points.data"></mat-spinner>
                <ng-container *ngIf="!loading.info2Points && points.info2Points.data">
                    <div class="d-flex justify-content-between">
                        <span>Informações sobre os pontos</span>
                        <mat-icon (click)="closeInfos2Points()" class="pointer">close</mat-icon>
                    </div>
                    <div class="row">
                        <div class="col-6 mb-2">
                            <span class="fs-5">{{ points.info2Points.data.disponibilidadeTotalMinutes }}</span>
                            <div class="fs-7 fw-lighter text-gray">Disponibilidade Total</div>
                        </div>
                        <div class="col-6 mb-2">
                            <span class="fs-5">{{ points.info2Points.data.funcionamentoTotalMinutes }}</span>
                            <div class="fs-7 fw-lighter text-gray">Funcionamento Total</div>
                        </div>                        
                        <div class="col-6">
                            <span class="fs-5">{{ points.info2Points.data.kmRodadosByOdometro }}</span>
                            <div class="fs-7 fw-lighter text-gray">KM Rodados</div>
                        </div>
                        <div class="col-6">
                            <span class="fs-5 text-short">{{ points.info2Points.start | date:'dd/MM/yyyy HH:mm'}}</span>
                            <div class="fs-7 fw-lighter text-gray">Data/Hora Início</div>
                        </div>
                        <div class="col-6 text-short">
                            <span class="fs-5">{{ points.info2Points.end | date:'dd/MM/yyyy HH:mm'}}</span>
                            <div class="fs-7 fw-lighter text-gray">Data/Hora Fim</div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- AÇÕES -->
            <div id="map-actions" [ngClass]="{'show ms-2': show.actions}" *ngIf="canSeeActions()">
                <button mat-mini-fab class="mb-2" [ngClass]="show.options ? 'bg-primary' : 'bg-white text-black'" (click)="showDiv('options')"
                    matTooltip="Opções" matTooltipPosition="left">
                    <mat-icon>tune</mat-icon>
                </button>
                <button mat-mini-fab class="mb-2" [ngClass]="show.timeline ? 'bg-primary' : 'bg-white text-black'" (click)="showDiv('timeline')"
                    matTooltip="Ponto a ponto" matTooltipPosition="left">
                    <mat-icon fontSet="material-icons-outlined">push_pin</mat-icon>
                </button>
                <button mat-mini-fab class="mb-2 bg-danger" (click)="showDiv('cancels')"
                    matTooltip="Registrar Apontamentos" matTooltipPosition="left">
                    <mat-icon fontSet="material-icons-outlined">wrong_location</mat-icon>
                </button>
                <button mat-mini-fab class="mb-2" [ngClass]="show.legend ? 'bg-primary' : 'bg-white text-black'" (click)="showDiv('legend')"
                    matTooltip="Legenda" matTooltipPosition="left">
                    <mat-icon>help_outline</mat-icon>
                </button>
            </div>

            <!-- OPÇÕES -->
            <div class="map-right-side overflow-visible text-nowrap" [ngClass]="{'show px-3': show.options}">
                <div class="my-3">
                    <mat-slide-toggle color="primary" [(ngModel)]="points.dio" (change)="toggleDioPoints($event)">Percurso aferido</mat-slide-toggle>
                </div>
                <div class="mb-3" *ngIf="false">
                    <mat-slide-toggle color="primary" disabled>Percurso previsto</mat-slide-toggle>
                </div>
                <div class="mb-3">
                    <mat-slide-toggle color="primary" [(ngModel)]="points.stop" (change)="toggleStopPoint($event)">Detecção de parada</mat-slide-toggle>
                </div>
                <div class="mb-3">
                    <mat-slide-toggle color="primary" (change)="toggleHeatMap($event)">Mapa de calor</mat-slide-toggle>
                </div>
                <div class="mb-3">
                    <mat-slide-toggle color="primary" [(ngModel)]="points.directions" (change)="toggleDirections($event)">Ver direções</mat-slide-toggle>
                </div>
                <div class="mb-3" *ngIf="false">
                    <mat-slide-toggle color="primary" disabled>DIO's semelhantes <span class="status-badge bg-danger text-white">3</span></mat-slide-toggle>
                </div>
                <div class="d-flex">
                    <mat-form-field class="w-100">
                        <mat-label>Inicio</mat-label>
                        <input matInput name="startTimeInput" #startTimeInput="ngModel" (change)="getDataPositionsByTime()"
                            [(ngModel)]="startTime" mask="Hh:m0" placeholder="--:--">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Fim</mat-label>
                        <input matInput name="endTimeInput" #endTimeInput="ngModel" (change)="getDataPositionsByTime()"
                            [(ngModel)]="endTime" mask="Hh:m0" placeholder="--:--">
                    </mat-form-field>
                </div>
                <!-- COMPARAR DIO OCULTADO A PEDIDO DO MARCELO -->
                <!--
                <div>
                    <ng-select name="user" [items]="dios$ | async" bindValue="id" [typeahead]="diosInput$" [loading]="loading.dios"
                        placeholder="Comparar DIO" typeToSearchText="Buscar DIO's..." notFoundText="Nenhum item encontrado" loadingText="Buscando..."
                        [(ngModel)]="diosCompare">
                        <ng-template ng-label-tmp ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <span>#{{ item.numero }} - {{ item.servico.titulo }}</span>
                        </ng-template>
                    </ng-select>
                </div>
                -->
            </div>

            <!-- PONTO A PONTO -->
            <div class="map-right-side overflow-auto" [ngClass]="{'show': show.timeline}">
                <mat-card class="rounded-end-0 mh-100">
                    <mat-card-content class="d-flex flex-column p-0 mh-100 ">
                        <div class="text-center text-muted py-4" *ngIf="!dataPositionsFiltered || !dataPositionsFiltered.length">
                            Nenhum ponto encontrado
                        </div>
                        <mat-accordion class="overflow-auto" *ngIf="dataPositionsFiltered && dataPositionsFiltered.length">
                            <mat-expansion-panel (opened)="showPoint(index)" (closed)="panelOpenState[index] = false"
                                *ngFor="let data of dataPositionsFiltered; index as index">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="flex-column align-items-start justify-content-between py-3 lh-sm">
                                        <span class="status-badge bg-{{ data.ignicao ? 'danger' : 'success' }} text-white">{{ data.ignicao ? 'Desligado' : 'Ligado' }}</span>
                                        <div class="row row-cols-2 g-2 fs-7 lh-sm mt-0">
                                            <div>
                                                <div class="fw-lighter">Data/Hora</div>
                                                <span>{{ data.data_transmissao | date:'dd/MM/yyyy HH:mm:ss' }}</span>                                                
                                            </div>
                                        </div>
                                        <div class="row row-cols-2 g-2 fs-7 lh-sm mt-0">
                                            <div>
                                                <div class="fw-lighter">Bateria</div>
                                                <span>{{ data.bateria }}</span>
                                            </div>
                                            <div>
                                                <div class="fw-lighter">Velocidade</div>
                                                <span>{{ data.velocidade }}km/h</span>
                                            </div>
                                            <div class="mt-2">
                                                <div class="fw-lighter">Odometro</div>
                                                <span>{{ data.odometro }} km</span>
                                            </div>
                                            <div class="mt-2">
                                                <div class="fw-lighter">Horímetro</div>
                                                {{ data.horimetro || '---' }}
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <!-- expanded -->
                                <div class="mt-2 fs-7 lh-sm">
                                    <div class="fw-lighter">Lat/Lng</div>
                                    <span class="fw-medium">{{ data.geolocalizacao }}</span>
                                </div>
                                <div class="mt-2 fs-7 lh-sm">
                                    <div class="fw-lighter">Endereço</div>
                                    <span class="fw-medium">{{ data.logradouro || '---' }}</span>
                                </div>
                                <!-- expanded -->

                            </mat-expansion-panel>
                        </mat-accordion>
                    </mat-card-content>
                </mat-card>
            </div>

            <!-- REGISTRAR APONTAMENTOS -->
            <div class="map-right-side" [ngClass]="{'show': show.cancels}">
                <div class="d-flex flex-column p-0 mh-100 overflow-hidden">
                    <div class="pt-3 px-3 overflow-auto">
                        <app-list-apontamentos
                            [apontamentos]="particalCancels"
                            [dio]="dio"
                            [afericao]="afericao"
                            [currentRole]="currentRole"
                            (cancelApontamento)="responseCancelarApontamento($event)">
                            </app-list-apontamentos>
                    </div>
                    <div class="d-flex flex-column pb-3 px-3">
                        <button mat-flat-button class="bg-warning" *ngIf="canRegisterAppointment()" (click)="showCancelDialog(false)">REGISTRAR APONTAMENTOS</button>
                    </div>
                </div>
            </div>

            <!-- LEGENDA -->
            <div class="map-right-side" [ngClass]="{'show px-3 py-2': show.legend}">
                <mat-list>
                    <mat-list-item class="py-1 px-0">
                        <div class="d-flex align-items-center mb-1">
                            <mat-icon class="icon-sm ms-1 me-2" style="color: #11a324">circle</mat-icon>
                            <span>Ignição ligada</span>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="py-1 px-0">
                        <div class="d-flex align-items-center mb-1">
                            <mat-icon class="icon-sm ms-1 me-2" style="color: rgb(245, 10, 10)">circle</mat-icon>
                            <span>Ignição desligada</span>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="py-1 px-0">
                        <img class="me-1 mb-1" height="26px" src="/assets/img/pin_block.svg" alt="Inicio">
                        <span>Parado</span>
                    </mat-list-item>
                    <mat-list-item class="py-1 px-0">
                        <img class="ms-1 me-2" height="20px" src="/assets/img/flag_start.svg" alt="Inicio">
                        <span>Inicio do trajeto</span>
                    </mat-list-item>
                    <mat-list-item class="py-1 px-0">
                        <img class="ms-1 me-2" height="20px" src="/assets/img/flag_end.svg" alt="Inicio">
                        <span>Fim do trajeto</span>
                    </mat-list-item>
                </mat-list>
            </div>

            <!-- MAPA -->
            <div class="flex-fill rounded" id="map"></div>
        </div>                                

        <div class="d-flex pb-3">
            <button mat-flat-button class="bg-white px-5 ms-auto" (click)="changeSideBar()">
                {{ hideBreadcrumb? 'RECOLHER MAPA' : 'EXPANDIR MAPA' }}
            </button>
            <button *ngIf="canRegisterAppointment()" mat-flat-button class="bg-warning px-5 ms-auto" (click)="showCancelDialog(false)">
                REGISTRAR APONTAMENTOS
            </button>
            <button mat-flat-button class="bg-success text-white px-5 ms-2" [ngClass]="{'btn-dialog-spinner': loading.afericao}" 
                    (click)="openToSignDialog()" *ngIf="isModoAtestoFuncionario()">                
                <span *ngIf="!loading.afericao">ATESTAR DIO</span>
            </button>
            <button mat-flat-button class="bg-success text-white px-5 ms-2" [ngClass]="{'btn-dialog-spinner': loading.afericao}" 
                    (click)="openToSignDialog()" *ngIf="isModoValidacaoFiscal()">                
                <span *ngIf="!loading.afericao">VALIDAR DIO</span>  
            </button>
            <button mat-flat-button class="bg-success text-white px-5 ms-2" [ngClass]="{'btn-dialog-spinner': loading.afericao}" 
                (click)="finish()" *ngIf="afericao && afericao.status != 'PENDENTE_APROVACAO'">
                <mat-spinner class="btn-spinner" *ngIf="canFinishAfericao()"></mat-spinner>
                <span *ngIf="!loading.afericao">FINALIZAR AFERIÇÃO</span>
            </button>
            <button mat-flat-button class="bg-success text-white px-5 ms-2" [ngClass]="{'btn-dialog-spinner': loading.afericao}"
                (click)="aprove()" *ngIf="canAproveOrDeleteAfericao()">
                <mat-spinner *ngIf="loading.afericao" class="btn-spinner"></mat-spinner>
                <span *ngIf="!loading.afericao">APROVAR AFERIÇÃO</span>  
            </button>            
            <button mat-flat-button class="bg-white px-5 ms-2" [routerLink]="['/dio', this.dio.id, 'visualizar']">
                VOLTAR
            </button>
        </div>
    </div>
</div>

